import { combineReducers } from "redux";
import user from "./userReducer";
import loading from "./loadingReducer";
import isLoggedIn from "./isLoggedInReducer";
import changeImage from "./chageImageReducer";
import changeNameOrCareerReducer from "./changeNameOrCareerReducer";
import opeationSuccess from "./operationSuccessRedurer";
import hasPersonalDataReducer from "./hasPersonalDataReducer";
import hasVehicleDataReducer from "./hasVehicleDataReducer";
import hasFamilyStructureDataReducer from "./hasFamilyStructureDataReducer";
import hasEducationDataReducer from "./hasEducationDataReducer";
import hasLanguageDataReducer from "./hasLanguageDataReducer";
import hasKnowledgeDataReducer from "./hasKnowledgeDataReducer";
import hasExperienceDataReducer from "./hasExperienceDataReducer";
import hasReferenceDataReducer from "./hasReferencesDataReducer";
import hasJobInformationDataReducer from "./hasJobInformationDataReducer";
import hasAttachmentDataReducer from "./hasAttachmentDataReducer";
import isRequiredModuleReducer from "./isRequiredModuleReducer";
import hasTalentsDataReducer from "./hasTalentsDataReducer";

export default combineReducers({
  user,
  loading,
  isLoggedIn,
  changeImage,
  changeNameOrCareerReducer,
  opeationSuccess,
  hasPersonalDataReducer,
  hasVehicleDataReducer,
  hasFamilyStructureDataReducer,
  hasEducationDataReducer,
  hasLanguageDataReducer,
  hasKnowledgeDataReducer,
  hasExperienceDataReducer,
  hasReferenceDataReducer,
  hasJobInformationDataReducer,
  hasAttachmentDataReducer,
  isRequiredModuleReducer,
  hasTalentsDataReducer,
});
